import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import typeStyles from './style/type.css';
import locationStyles from './style/location.css';

const cx = classNames.bind({
  ...locationStyles,
  ...typeStyles,
});

export default function Position({
  bottom,
  children,
  fullWidth,
  left,
  location,
  right,
  top,
  type,
}) {
  const classes = cx([type], [location], {
    'width-100': fullWidth,
  });
  const style = {
    bottom,
    left,
    right,
    top,
  };
  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}

Position.propTypes = {
  bottom: PropTypes.number,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  left: PropTypes.number,
  location: PropTypes.oneOf(Object.keys(locationStyles)),
  right: PropTypes.number,
  top: PropTypes.number,
  type: PropTypes.oneOf(Object.keys(typeStyles)),
};

Position.defaultProps = {
  fullWidth: false,
  type: 'absolute',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-position/Position/index.js